import script from "./DtfArtCleanupCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DtfArtCleanupCard.vue?vue&type=script&setup=true&lang=js"

import "./DtfArtCleanupCard.vue?vue&type=style&index=0&id=b7a654bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7a654bc"]])

export default __exports__